/**
 * 슬라이드 상태
 * https://github.kakaocorp.com/kakaopage/api/blob/c504da353ca91b8232efe15181ed129028984320/common/src/main/java/com/kakaopage/common/model/enums/SlideState.java#L18
 */
export enum SlideStateVo {
  /**
   * 제작중
   */
  ST21 = 'ST21',
  /**
   * 제작완료
   */
  ST22 = 'ST22',
  /**
   * 발행됨
   */
  ST23 = 'ST23',
  /**
   * 미발행
   */
  ST30 = 'ST30',
  /**
   * 심사신청
   */
  ST40 = 'ST40',
  /**
   * 임시승인
   */
  ST41 = 'ST41',
  /**
   * 심사할당
   */
  ST45 = 'ST45',
  /**
   * 심사중
   */
  ST50 = 'ST50',
  /**
   * 승인완료
   */
  ST51 = 'ST51',
  /**
   * 승인반려
   */
  ST52 = 'ST52',
  /**
   * 후심사중
   */
  ST53 = 'ST53',
  /**
   * 심사보류
   */
  ST54 = 'ST54',
  /**
   * 판매중
   */
  ST61 = 'ST61',
  /**
   * 판매중지 (발행자가 직접 중지)
   */
  ST62 = 'ST62',
  /**
   * 판매예약
   */
  ST63 = 'ST63',
  /**
   * 판매금지 (운영자가 판매 금지 시킨 경우, 발행자는 금지 풀릴 때까지 판매할)
   */
  ST64 = 'ST64',
  /**
   * 알수없음
   */
  ST99 = 'ST99',
}
